export const STATUS_DISCONNECTED = 'Disconnected'